/**
 * This function converts stringified boolean to boolean
 * @param value
 * @returns {boolean}
 */
export default value => {
  switch (value) {
    case true:
    case 'true':
      return true
    case false:
    case 'false':
      return false
  }
}
